import React from "react";
import { Alert } from "./ui";

const SuccessAlert = ({ message }) => (
  <Alert tone="success" className="mt-2">
    {message}
  </Alert>
);

export default SuccessAlert;
